import React, { useState, useEffect } from "react";
import {
  Typography,
  Divider,
  Row,
  Col,
  Button,
  Upload,
  message,
  Form,
  Image,
  Dropdown,Space, Switch
} from "antd";
import { DownOutlined, InboxOutlined } from "@ant-design/icons";
import { getCertificates } from "../../../services/CertificateService";
import TestimonialService from "../../../services/TestimonialService";
import MenuService from "../../../services/MenuService";
import CustomizationService from "../../../services/CustomizationService";
import CustomInput from "../../../components/CustomInput";
import CustomTextArea from "../../../components/CustomTextArea";
import CustomSelect from "../../../components/CustomSelect";
import HomeTemplate from "./HomeTemplate";
import { useHistory } from "react-router-dom";


import {
  checkResolution,
  convertFormDataToObject,
  dummyRequest,
  transformImageFileToUrlObject,
} from "../../../utils";

import _ from "lodash";
import AddTestimonial from "../Testimonials/AddTestimonial";
import AddCertificate from "../Certifications/AddCertification";

const { Dragger } = Upload;
const { Title } = Typography;

function Home() {
  const [customizationData, setCustomizationData] = useState({});
  const [formFieldsdata, setFormFieldsData] = useState();
  const [menus, setMenus] = useState([]);
  const [Featuredmenu, setFeaturedMenu]= useState()
  const [menuItems, setMenuItems] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [showTestimonialModal, setShowTestimonialModal] = useState(false);
  const [certificates, setCertificates] = useState([]);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();

  const [selectedMenuID,setSelectedMenu] = useState() 

  let restaurantID = localStorage.getItem("restaurantId");

  useEffect(() => {
    
    fetchTestimonials();
    fetchCertificates();
    fetchCustomizationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    
      
      setSelectedMenu(form.getFieldsValue()?.featured_menu)
      const allMenuItems =
  menus
    ?.filter(menu => form.getFieldsValue()?.featured_menu?.includes(menu.id))   // get all matched menus
    ?.flatMap(menu => menu.menu_items || []);
      setMenuItems(allMenuItems)

      const validMenuItemIds = menus
    .filter(m => form.getFieldsValue()?.featured_menu?.includes(m.id))
    .flatMap(m => m.menu_items.map(mi => mi.id));

  const updated = form.getFieldsValue()?.featured_menu_ids?.filter(id =>
    validMenuItemIds.includes(id)
  );

  form.setFieldsValue({ featured_menu_ids: updated || [] });     
    
  }, [form.getFieldsValue()?.featured_menu,menus]);

  

 

  const fetchMenus = async () => {
    const data = await MenuService.getMenus(restaurantID);
    setMenus(data?.menus || []);
  };

  const fetchMenuItems = async () => {
    const filteredMenu = menus.filter((menu) => menu.id === selectedMenuID)[0];
    const filteredMenuItems = _.filter(filteredMenu?.menu_items, {
      is_active: true,
    });
    setMenuItems(filteredMenuItems);
  };

  const fetchCertificates = async () => {
    const data = await getCertificates();
    setCertificates(data?.certifications || []);
  };

  const onAddorUpdateCertificates = () => {
    fetchCertificates();
    setShowCertificateModal(false);
  };

  const onAddorUpdateTestimonials = () => {
    fetchTestimonials();
    setShowTestimonialModal(false);
  };

  const fetchTestimonials = async () => {
    const data = await TestimonialService.getTestimonials(restaurantID);
    setTestimonials(data?.testimonials || []);
  };

  const removeNullValues = (obj) => {
    // Create a new object without null values
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => value !== null)
    );
  };

  const saveCustomizationData = async () => {
    setIsSaving(true);
    try {
      // let transformedFormData = await transformImageFileToUrlObject({
      //   ...customizationData,
      // });
      const cleanedPayload = removeNullValues(formFieldsdata);
      if(cleanedPayload.featured_menu)
        {
          cleanedPayload.menu_item_ids = cleanedPayload.featured_menu
        delete cleanedPayload.featured_menu;
        }
        delete cleanedPayload?.menu_items;
        delete cleanedPayload?.banner_heading;
        delete cleanedPayload?.catering_event_types;
        delete cleanedPayload?.certifications;
        delete cleanedPayload?.created_at;
        delete cleanedPayload?.id;
        delete cleanedPayload?.landing_page_button_title;
        delete cleanedPayload?.our_story_description;
        delete cleanedPayload?.restaurant_id;
        delete cleanedPayload?.restaurant_special_tagline;
        delete cleanedPayload?.testimonials;
        delete cleanedPayload?.theme;
        delete cleanedPayload?.updated_at;
        delete cleanedPayload?.updated_by;
      const updatedData = {
        ...cleanedPayload,
        our_story_featured_menu: Number(Featuredmenu)
    };
    const saveBuilder =   await CustomizationService.saveCustomization(
        restaurantID,
        updatedData
      );
      if (saveBuilder)
      message.success("Update Successful");
      
     
      // delete cleanedPayload.testimonial_ids;
      // delete cleanedPayload.certificate_ids;
     
    } catch (error) {
      setIsSaving(false);
      message.error("Update Failed");
    }
  };

  
    
  const fetchCustomizationData = async () => {
    await fetchMenus();
    const data = await CustomizationService.getCustomizations(restaurantID);
    setFeaturedMenu(data?.our_story_featured_menu)
    if(data.menu_item_ids)
    {
      data.featured_menu = data.menu_item_ids
    }
    form.setFieldsValue(data);
    setFormFieldsData(data)
    setCustomizationData(data);
  };
  const handleMenuClick = (e) => {
   
  };

  const items = [
    {
      label: 'Image',
      key: '1',
     
    },
    {
      label: 'Heading',
      key: '2',
      
    },
    {
      label: 'Sub-heading',
      key: '3',
     
    },
    {
      label: 'Text field',
      key: '4',
      
      
    },
    {
      label: 'Button',
      key: '5',
      
      
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  const addNewSectionMenu = ()=>{
    // return(
    //   <Dropdown menu={menuProps}>
    //   <Button type="primary">
    //     <Space>
    //       Add Field
    //       <DownOutlined />
    //     </Space>
    //   </Button>
    // </Dropdown>
    // )
  }

  const beforeUpload = async (file,type) => {
    

    
    // const isResolutionValid = await checkResolution(file);
    // if (!isResolutionValid) 
    //   {
    //     message.error("Image resolution must be greater than 1000 X 500");
    //     return false;
    //   }
  
    // const formData = new FormData();
    // formData.append("file", file);
    // const data = await TestimonialService.uploadPhoto(formData);
    // if(data){
    //   form.setFieldsValue({[type]: data.url})
    //   setFormFieldsData(form.getFieldsValue())
    // } 
  };
  const handleImageChange =async(info,type)=>{
    if (info.file.status === 'done'){
    const isResolutionValid = await checkResolution(info.file.originFileObj);
    if (!isResolutionValid) 
          {
            message.error("Image resolution must be greater than 1920 X 1080");
            return;
          }
        
    const formData = new FormData();
        formData.append('file', info.file.originFileObj);
        const  data  = await TestimonialService.uploadPhoto(formData); 
        if(data){
          form.setFieldsValue({[type]: data.url})
          setFormFieldsData(form.getFieldsValue())
        }  
      }
  }
  const gandleFormValueChanges = (changedValue, allValues)=>{
    setFormFieldsData(form.getFieldsValue())
  }

  
  return (
    <Row
      style={{
        background: "#FFFFFF",
        padding: 16,
        borderRadius: 5,
      }}
      gutter={[16,16]}
    >
      <Col xs={24} lg={12}>
      <Form
        form={form}
        name="story"
        onValuesChange={gandleFormValueChanges}
        onFieldsChange={(_, allFields) => {
          
          
          setCustomizationData(convertFormDataToObject(allFields));
        }}
        scrollToFirstError
        // style={{ width: "50%" }}
      >
        <div className="theme-container">
          <Row>
            <Col span={24}>
              <Title level={5} className="theme-red mb-1 web-heading">
                <div>
                Landing Section
                </div>
                {addNewSectionMenu()}
              </Title>
             
              <Form.Item name="landing_page_restaurant_name">
                <CustomInput
                  label="Restaurant Name"
                  placeholder="Enter restaurant name here"
                />
              </Form.Item>
              <Form.Item name="landing_page_button_title">
                <CustomInput
                  label="Button Title "
                  placeholder="Enter button title here"
                />
              </Form.Item>
              <div className="mb-1">Upload BG Image</div>
              <Form.Item name="landing_page_image_url">
                <Dragger multiple={false} customRequest={dummyRequest}
                onChange={(info)=>handleImageChange(info,'landing_page_image_url')}
               >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag image file to this area to upload
                  </p>
                </Dragger>
                {/* {typeof customizationData?.landing_page_image_url ===
                  "string" && (
                  <Image
                    width={200}
                    src={customizationData?.landing_page_image_url}
                  />
                )} */}
              </Form.Item>
              <Divider />
              <Title level={5} className="theme-red mb-1 web-heading">
                <div>Restaurant Special</div>
                {addNewSectionMenu()}
              </Title>
              <Form.Item name="restaurant_special_tagline">
                <CustomInput
                  label="Restaurant Tagline"
                  placeholder="Enter restaurant tagline here"
                />
              </Form.Item>
              <Form.Item name="restaurant_special_description">
                <CustomTextArea
                  label="Description"
                  placeholder="Enter description here"
                />
              </Form.Item>
              <div className="mb-1">Upload Image</div>
              <Form.Item name="restaurant_special_image_url">
                <Dragger multiple={false} customRequest={dummyRequest}
                 onChange={(info)=>handleImageChange(info,'restaurant_special_image_url')}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag image file to this area to upload
                  </p>
                </Dragger>
              </Form.Item>
              {typeof customizationData?.restaurant_special_image_url ===
                "string" && (
                <Image
                  width={200}
                  src={customizationData?.restaurant_special_image_url}
                />
              )}
              <Divider />
              <Title level={5} className="theme-red mb-1 web-heading">
               <div>Featured Menu Items</div> 
               {addNewSectionMenu()}
              </Title>
              <Form.Item name="featured_menu">
                <CustomSelect
                  label="Menu"
                  mode="multiple"
                  placeholder="Select menu here"
                  options={menus}
                  style={{ width: "100%" }}
                  fieldNames={{ value: "id", label: "name" }}
                />
              </Form.Item>
              <Form.Item name="featured_menu_ids">
                <CustomSelect
                  label="Menu Item"
                  placeholder="Select menu item here"
                  mode="multiple"
                  options={menuItems}
                  style={{ width: "100%" }}
                  fieldNames={{ value: "id", label: "name" }}
                  showSearch
                  // filterOption={(input, option) =>
                  //   (option?.label ?? "")
                  //     .toLowerCase()
                  //     .includes(input.toLowerCase())
                  // }
                />
              </Form.Item>
              <div className="justify-center d-flex mb-1">
                <Button
                  type="outline"
                  className="btn-custom outline"
                  onClick={() => {history.push('/menu/add')}}
                >
                  Add Menus
                </Button>
              </div>
              <Divider />
              <Title level={5} className="theme-red mb-1 web-heading">
                <div>Testimonials</div>
                {addNewSectionMenu()}
              </Title>
              <Form.Item name="testimonial_ids">
                <CustomSelect
                  label="Testimonial"
                  placeholder="Select Testimonials here"
                  mode="multiple"
                  options={testimonials}
                  style={{ width: "100%" }}
                  fieldNames={{ value: "id", label: "customer_name" }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
              <div className="justify-center d-flex mb-1">
                <Button
                  type="outline"
                  className="btn-custom outline"
                  onClick={() => setShowTestimonialModal(true)}
                >
                  Add Testimonial
                </Button>
              </div>
              <Divider />
              <Title level={5} className="theme-red mb-1 web-heading">
                <div>Banner</div>
                {addNewSectionMenu()}
              </Title>
              <Form.Item name="banner_heading">
                <CustomInput label="Heading" placeholder="Enter Heading here" />
              </Form.Item>
              <Form.Item name="banner_subheading">
                <CustomInput
                  label="Subheading"
                  placeholder="Enter Subheading here"
                />
              </Form.Item>
              <div className="mb-1">Upload Image</div>
              <Form.Item name="banner_image_url">
                <Dragger multiple={false} customRequest={dummyRequest}
                onChange={(info)=>handleImageChange(info,'banner_image_url')}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag image file to this area to upload
                  </p>
                </Dragger>
              </Form.Item>
              {typeof customizationData?.banner_image_url === "string" && (
                <Image width={200} src={customizationData?.banner_image_url} />
              )}
              <Divider />
              <Title level={5} className="theme-red web-heading">
                <div>Story</div>
                {addNewSectionMenu()}
              </Title>
              <Form.Item name="story_heading">
                <CustomInput label="Heading" placeholder="Enter Heading here" />
              </Form.Item>
              <Form.Item name="story_subheading">
                <CustomInput
                  label="Subheading"
                  placeholder="Enter Subheading here"
                />
              </Form.Item>
              <div className="mb-1">Upload Image</div>
              <Form.Item name="story_image_url">
                <Dragger multiple={false} customRequest={dummyRequest}
                onChange={(info)=>handleImageChange(info,'story_image_url')}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag image file to this area to upload
                  </p>
                </Dragger>
              </Form.Item>
              {/* {typeof customizationData?.story_image_url === "string" && (
                <Image width={200} src={customizationData?.story_image_url} />
              )} */}
              <Divider />
              <Title level={5} className="theme-red mb-1 web-heading">
                <div>Certification</div>
                {addNewSectionMenu()}
              </Title>
              <Form.Item name="certificate_ids">
                <CustomSelect
                  label="Certification"
                  placeholder="Select certification here"
                  mode="multiple"
                  options={certificates}
                  style={{ width: "100%" }}
                  fieldNames={{ value: "id", label: "name" }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
              <div className="justify-center d-flex mb-1">
                <Button
                  type="outline"
                  className="btn-custom  outline"
                  onClick={() => setShowCertificateModal(true)}
                >
                  Add certificates
                </Button>
              </div>
              <Divider />
              <Title level={5} className="theme-red mb-1 web-heading">
                <div>Footer</div>
                {addNewSectionMenu()}
              </Title>
              <Form.Item name="facebook_url">
                <CustomInput
                  label="Link for Facebook"
                  placeholder="Enter facebook link here"
                />
              </Form.Item>
              <Form.Item name="instagram_url">
                <CustomInput
                  label="Link for Instagram"
                  placeholder="Enter instagram link here"
                />
              </Form.Item>
              <Form.Item name="pinterest_url">
                <CustomInput
                  label="Link for Pinterest"
                  placeholder="Enter pinterest link here"
                />
              </Form.Item>
              <Form.Item name="linkedin_url">
                <CustomInput
                  label="Link for LinkedIn"
                  placeholder="Enter linkedIn link here"
                />
              </Form.Item>
              <Form.Item name="twitter_url">
                <CustomInput
                  label="Link for Twitter"
                  placeholder="Enter twitter link here"
                />
              </Form.Item>
              <p className="ant-upload-text mt-2" style={{ color: "#3A3A3A" }}>
                This footer will remain constant through out the website.
              </p>
              <Divider />
              <Title level={5} className="theme-red mb-1 web-heading">
                <div>Reservation</div>
               
              </Title>
              <div><Switch   /> Allow Reservation</div>
            </Col>
          </Row>
          <div className="flex justify-center mt-2">
            <Button
              type="primary"
              className="custom-btn"
              // disabled={isSaving}
              onClick={saveCustomizationData}
            >
              Save
            </Button>
          </div>
        </div>
      </Form>
      </Col>
      <Col xs={24} lg={12}>
        <HomeTemplate data={customizationData} formFieldsdata = {formFieldsdata}
                  menuItems={menuItems}
                  testimonials={testimonials}
                  certificates={certificates}
                  />
      </Col>
      
      <AddTestimonial
        modalOpen={showTestimonialModal}
        isEdit={false}
        closeModal={() => setShowTestimonialModal(false)}
        onAddorUpdate={onAddorUpdateTestimonials}
      />
      <AddCertificate
        modalOpen={showCertificateModal}
        isEdit={false}
        closeModal={() => setShowCertificateModal(false)}
        onAddorUpdate={onAddorUpdateCertificates}
      />
    </Row>
  );
}

export default React.memo(Home);
